import React from 'react';
import dynamic from 'next/dynamic';

const iconMap = {
  Facebook: dynamic(() => import('./Facebook')),
  Instagram: dynamic(() => import('./Instagram')),
  Linkedin: dynamic(() => import('./Linkedin')),
  Whatsapp: dynamic(() => import('./Whatsapp')),
  Youtube: dynamic(() => import('./Youtube')),
  Location: dynamic(() => import('./Location')),
  Caller: dynamic(() => import('./Caller')),
  Message: dynamic(() => import('./Message')),
  Amex: dynamic(() => import('./Amex')),
  Mastercard: dynamic(() => import('./Mastercard')),
  Visa: dynamic(() => import('./Visa')),
  Bkash: dynamic(() => import('./Bkash')),
  Nagad: dynamic(() => import('./Nagad')),
  Rocket: dynamic(() => import('./Rocket')),
  ArrowLeft: dynamic(() => import('./ArrowLeft')),
  ArrowRight: dynamic(() => import('./ArrowRight')),
  User: dynamic(() => import('./User')),
  Cart: dynamic(() => import('./Cart')),
  Beko: dynamic(() => import('./Beko')),
  Singeronly: dynamic(() => import('./Singeronly')),
  Search: dynamic(() => import('./Search')),
  AddToCart: dynamic(() => import('./AddToCart')),
  SeeDetails: dynamic(() => import('./SeeDetails')),
  MegaDealStar: dynamic(() => import('./MegaDealStar')),
  Heart: dynamic(() => import('./Heart')),
  StarGoldOutline: dynamic(() => import('./StarGoldOutline')),
  StarGoldOutlineHalfFill: dynamic(() => import('./StarGoldOutlineHalfFill')),
  StarGoldFill: dynamic(() => import('./StarGoldFill')),
  Bin: dynamic(() => import('./Bin')),
  Plus: dynamic(() => import('./Plus')),
  Minus: dynamic(() => import('./Minus')),
  AngleDown: dynamic(() => import('./AngleDown')),
  Filter: dynamic(() => import('./Filter')),
  Grid: dynamic(() => import('./Grid')),
  Close: dynamic(() => import('./Close')),
  List: dynamic(() => import('./List')),
  CheckmarkRed: dynamic(() => import('./CheckmarkRed')),
  Circle: dynamic(() => import('./Circle')),
  FlagUS: dynamic(() => import('./FlagUS')),
  CheckmarkRoundedBg: dynamic(() => import('./CheckMarkRoundedBg')),
  ShoppingBag: dynamic(() => import('./ShoppingBag')),
  CallOut: dynamic(() => import('./CallOut')),
  Like: dynamic(() => import('./Like')),
  ArrowRound: dynamic(() => import('./ArrowRound')),
  Share: dynamic(() => import('./Share')),
  Shield: dynamic(() => import('./Shield')),
  Info: dynamic(() => import('./Info')),
  ZoomIn: dynamic(() => import('./ZoomIn')),
  ZoomOut: dynamic(() => import('./ZoomOut')),
  AngleRightBold: dynamic(() => import('./AngleRightBold')),
  Email: dynamic(() => import('./Email')),
  Phone: dynamic(() => import('./Phone')),
  Compare: dynamic(() => import('./Compare')),
  StarGrey: dynamic(() => import('./StarGrey')),
  CloseRoundedBorder: dynamic(() => import('./CloseRoundedBorder')),
  HeartFill: dynamic(() => import('./HeartFill')),
  PlusIcon: dynamic(() => import('./PlusIcon')),
  StarGoldOutlineFill: dynamic(() => import('./StarGoldOutlineFill')),
  StarGoldHalfFill: dynamic(() => import('./StarGoldHalfFill')),
  TooltipDownArrow: dynamic(() => import('./TooltipDownArrow')),
  AngleRight: dynamic(() => import('./AngleRight')),
  CheckmarkRedSecondary: dynamic(() => import('./CheckmarkRedSecondary')),
  PlayCircle: dynamic(() => import('./PlayCircle')),
  Bell: dynamic(() => import('./Bell')),
  AngleDownBold: dynamic(() => import('./AngleDownBold')),
  Pause: dynamic(() => import('./Pause')),
  SingerBekoWhite: dynamic(() => import('./SingerBekoWhite')),
  Battery: dynamic(() => import('./Battery')),
  ComputerAndAccessories: dynamic(() => import('./ComputerAndAccessories')),
  Earphone: dynamic(() => import('./Earphone')),
  Fork: dynamic(() => import('./Fork')),
  Gear: dynamic(() => import('./Gear')),
  Propeller: dynamic(() => import('./Propeller')),
  SewingMachine: dynamic(() => import('./SewingMachine')),
  SmallAppliance: dynamic(() => import('./SmallAppliance')),
  WashingMachine: dynamic(() => import('./WashingMachine')),
  Home: dynamic(() => import('./Home')),
  Categories: dynamic(() => import('./Categories')),
  Offers: dynamic(() => import('./Offers')),
  MySinger: dynamic(() => import('./MySinger')),
  Television: dynamic(() => import('./Television')),
  PickupVan: dynamic(() => import('./PickupVan')),
  Emi: dynamic(() => import('./EMI')),
  CreditCard: dynamic(() => import('./CreditCard')),
  ColorPalette: dynamic(() => import('./ColorPalette')),
  Bin2: dynamic(() => import('./Bin2')),
  Radar: dynamic(() => import('./Radar')),
  Clipboard: dynamic(() => import('./Clipboard')),
  BookStack: dynamic(() => import('./BookStack')),
  CartBig: dynamic(() => import('./CartBig')),
  Warning: dynamic(() => import('./Warning')),
  AngleUpBold: dynamic(() => import('./AngleUpBold')),
  OrderStatus: dynamic(() => import('./OrderStatus')),
  Cash: dynamic(() => import('./Cash')),
  Calender: dynamic(() => import('./Calender')),
  AngleRight2: dynamic(() => import('./AngleRight2')),
  Chat: dynamic(() => import('./Chat')),
  Bin3: dynamic(() => import('./Bin3')),
  HamburgerMenu: dynamic(() => import('./HamburgerMenu')),
  Clock: dynamic(() => import('./Clock')),
  GradientCircle: dynamic(() => import('./GradientCirlcle')),
  HotOfferRectangleBadge: dynamic(() => import('./HotOfferRectangleBadge')),
  AngleLeft: dynamic(() => import('./AngleLeft')),
  Faq: dynamic(() => import('./FAQ')),
  WhatsappColor: dynamic(() => import('./WhatsappColor')),
  MessengerColor: dynamic(() => import('./MessengerColor')),
  FacebookColor: dynamic(() => import('./FacebookColor')),
  InstagramColor: dynamic(() => import('./InstagramColor')),
  LinkedInColor: dynamic(() => import('./LinkedInColor')),
  Line: dynamic(() => import('./Line')),
  Brand: dynamic(() => import('./Brand')),
  ThinRightArrow: dynamic(() => import('./ThinRightArrow')),
  Gift: dynamic(() => import('./Gift')),
  QuestionMark: dynamic(() => import('./QuestionMark')),
  Pen: dynamic(() => import('./Pen')),
  HelpRequest: dynamic(() => import('./HelpRequest')),
  SmallAC: dynamic(() => import('./SmallAC')),
  Blender: dynamic(() => import('./Blender')),
  SmallOven: dynamic(() => import('./SmallOven')),
  SmallWashingMachine: dynamic(() => import('./SmallWashingMachine')),
  DishWasher: dynamic(() => import('./DishWasher')),
  Watch: dynamic(() => import('./Watch')),
  WishlistEmptyPage: dynamic(() => import('./WishlistEmptyPage')),
  WrongOtp: dynamic(() => import('./WrongOtp')),
  RemoveBin: dynamic(() => import('./RemoveBin')),
  Camera: dynamic(() => import('./Camera')),
  ImagePlaceholder: dynamic(() => import('./ImagePlaceholder')),
  HeartOutline: dynamic(() => import('./HeartOutline')),
  MapWithPen: dynamic(() => import('./MapWithPen')),
  Career: dynamic(() => import('./Career')),
  InvestorRelation: dynamic(() => import('./InvestorRelation')),
  B2bSales: dynamic(() => import('./B2BSales')),
  Page: dynamic(() => import('./Page')),
  InstallmentOption: dynamic(() => import('./InstallmentOption')),
  Logout: dynamic(() => import('./Logout')),
  RatingOrder: dynamic(() => import('./RatingOrder')),
  PastOrder: dynamic(() => import('./PastOrder')),
  OngoingOrder: dynamic(() => import('./OngoingOrder')),
  UserIcon: dynamic(() => import('./UserIcon')),
  Shield2: dynamic(() => import('./Shield2')),
  AddToCart2: dynamic(() => import('./AddToCart2')),
  UserBorderRounded: dynamic(() => import('./UserBorderRounded')),
  Freezer: dynamic(() => import('./Freezer')),
  PowerSolution: dynamic(() => import('./PowerSolution')),
  SpareParts: dynamic(() => import('./SpareParts')),
  AirSolution: dynamic(() => import('./AirSolution')),
  TV: dynamic(() => import('./Tv')),
  HoodHub: dynamic(() => import('./HoodHub')),
  WaterHeater: dynamic(() => import('./WaterHeater')),
  TriangleVector: dynamic(() => import('./TriangleVector')),
  StoreLocation: dynamic(() => import('./StoreLocation')),
  CircleBlack: dynamic(() => import('./CircleBlack')),
  Coupon: dynamic(() => import('./Coupon')),
  CalendarSmall: dynamic(() => import('./calendarSmall')),
  LocationPinWithHome: dynamic(() => import('./LocationPinWithHome')),
  Tick: dynamic(() => import('./Tick')),
  Radio: dynamic(() => import('./Radio')),
  RadioActive: dynamic(() => import('./RadioActive')),
  ActiveCheckBox: dynamic(() => import('./ActiveCheckBox')),
  CheckBox: dynamic(() => import('./CheckBox')),
  CashGradient: dynamic(() => import('./CashGradient')),
  CalendarGradient: dynamic(() => import('./CalendarGradient')),
  AngleDown2: dynamic(() => import('./AngleDown2')),
  AngleLeftV2: dynamic(() => import('./AngleLeftV2')),
  EditLocation: dynamic(() => import('./EditLocation')),
  CancellationIcon: dynamic(() => import('./Cancellation')),
  NoInternet: dynamic(() => import('./NoInternet')),
  InfoError: dynamic(() => import('./InfoError')),
  ZoomImage: dynamic(() => import('./ZoomImage')),
  Wheel: dynamic(() => import('./Wheel')),
  Coupon2: dynamic(() => import('./Coupon2')),
  SingerLogo: dynamic(() => import('./SingerLogo')),
  ChatMenuIcon: dynamic(() => import('./ChatMenuIcon')),
};

function Icon({ type = '', ...rest }) {
  // Convert type to PascalCase to match keys in iconMap
  const pascalType = type
    .split('-')
    .map((word, i) =>
      i === 0
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join('');

  const IconComponent = iconMap[pascalType];

  if (!IconComponent) return null;
  return <IconComponent {...rest} />;
}

export default Icon;
